import React from 'react';
import { FDStack } from '@facet-wealth/design';
import UpdatedScenarioChartWithEmphasizedItems from 'Organisms/UpdatedScenarioChartWithEmphasizedItems';
import { RoadmapExplorerGoalsAccordion } from 'Components/UI/roadmapExplorer/goalsAccordion';
import { useRoadmapPaths } from 'Components/UI/guidedHouseholdReview/pathsContext';
import { GuidedHouseholdReviewLeftNav } from 'Components/UI/guidedHouseholdReview/leftNav';
import { PathSelectors } from './pathSelectors';
import { PathActions } from './pathActions';

export const RoadmapExplorerLayout = () => {
  const {
    resource, chartResource, goalsOnCurrentRoadmap, selectedPath, setSelectedPath, comparisonPaths, pathResource, showGoals, setShowGoals,
  } = useRoadmapPaths();

  return (
    <FDStack direction={'column'} spacing={8} height={'100%'}>
      <GuidedHouseholdReviewLeftNav showGoals={showGoals} setShowGoals={setShowGoals} pathResource={pathResource} roadmapExplorerResource={resource} size="lg" />
      <FDStack direction={'row'} padding={4} flex={1}>
        <FDStack
          direction="column"
          flex={1}
          minWidth={0}
        >
          <FDStack direction={'column'} spacing={2} justifyContent={'center'} alignItems={'center'}>
            <PathSelectors
              selectedPath={selectedPath}
              setSelectedPath={setSelectedPath}
              paths={resource.attr('paths').resources().list()}
            />
          </FDStack>

          {showGoals ? (
            <FDStack justifyContent="center" alignItems="center" flex={1} paddingY={2}>
              <FDStack justifyContent="center" alignItems="center" flex={1} overflow="auto">
                <RoadmapExplorerGoalsAccordion goals={goalsOnCurrentRoadmap} />
              </FDStack>
            </FDStack>
          ) : (
            <UpdatedScenarioChartWithEmphasizedItems
              selectedDataSetId={selectedPath}
              chartDataSourceIdsToShow={comparisonPaths}
              chartDataResource={chartResource}
              showLegend={false} // Do not show the legend because there should be separate controls for which roadmaps to show vs hide
            />
          )}
          <PathActions showGoals={showGoals} />
        </FDStack>
      </FDStack>
    </FDStack>
  );
};

RoadmapExplorerLayout.propTypes = {
};
